import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "./Reveal";

const LINKS = [
  ["prilezitosti", "Příležitosti"],
  ["nabidka", "Nabídka"],
  ["postup", "Postup"],
  ["poptavka", "Poptávka"],
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[var(--bg)]/80 border-b border-[var(--line)]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[68px] flex items-center justify-between">
        <Logo testId="header-logo" />
        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-${id}`} onClick={() => go(id)} className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--muted)] hover:text-[var(--ink)] transition-colors">
              {label}
            </button>
          ))}
          <button data-testid="header-cta" onClick={() => go("poptavka")} className="rounded-full bg-[var(--cyan)] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[var(--ink)] transition-colors">
            Chci nabídku
          </button>
        </nav>
        <button data-testid="mobile-menu-toggle" aria-label="Menu" onClick={() => setOpen(!open)} className="md:hidden w-11 h-11 grid place-items-center border border-[var(--line)] rounded-full">
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden border-t border-[var(--line)] bg-[var(--bg)]"
          >
            {LINKS.map(([id, label], i) => (
              <button key={id} data-testid={`mobile-nav-${id}`} onClick={() => go(id)} className="w-full text-left px-6 py-5 border-b border-[var(--line)] font-display text-2xl flex justify-between">
                {label}<span className="font-mono text-xs text-[var(--cyan)]">0{i + 1}</span>
              </button>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
